import { KeysService, allowedUnformattedKeyCodes } from 'plugins/keys/service/config/types';

/**
 * Convert key code to key.
 */
export function convertCodeToKey(code: string): string | undefined {
  let key: string | undefined;

  if (!code) {
    return;
  }

  if (code.includes('Digit')) {
    key = code.replace('Digit', '');
  } else if (code.includes('Key')) {
    key = code.replace('Key', '');
  } else if (code.includes(KeysService.Modifiers.Control)) {
    key = KeysService.Modifiers.Control;
  } else if (code.includes(KeysService.Modifiers.Shift)) {
    key = KeysService.Modifiers.Shift;
  } else if (code.includes(KeysService.Modifiers.Alt)) {
    key = KeysService.Modifiers.Alt;
  } else if (code.includes(KeysService.Modifiers.Meta)) {
    key = KeysService.Modifiers.Meta;
  } else if (allowedUnformattedKeyCodes.includes(code)) {
    key = code;
  }

  return key?.toLowerCase();
}
